<template>
    <div class="row justify-space-around mb-4">
      <router-link
        v-for="event in events"
        :key="event.id"
        :to="'/events/' + event.id"
        class="col-5 align-items-center topic ms-3 me-2"
        style="position: relative; height: fit-content; width: 42%; margin-top: 1em; text-align: center;"
        @click="goToEventDetail(event)"
      >
        <img :src="event.image" alt="Event Image" class="img-fluid" style="margin-top: 10px; border-radius: 8px;width:140px;height: 125px;" />
  
        <div class="small-div">
          <p style="margin: 0; font-size: 16px; font-weight: 600">{{ event.eventStartDate.substring(0, 2) }}</p>
          <p style="font-size: 10px">{{ event.eventMonth }}</p>
        </div>
        <p class="m-0 cat-text" style="font-weight: 600; margin-top: 1em !important; color: #030c12;white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ event.title }}</p>
        <div style="display: flex; align-items: center; margin-bottom: 0.8em" v-if="event.eventTime">
          <i
            class="bi me-2"
            style="font-size: 1rem; margin: 0px !important; color: #2f6787; width: 24px; height: 24px;"
          >
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.5 14.0671C3.88125 14.0671 0.9375 11.1234 0.9375 7.50464C0.9375 3.88589 3.88125 0.942139 7.5 0.942139C11.1187 0.942139 14.0625 3.88589 14.0625 7.50464C14.0625 11.1234 11.1187 14.0671 7.5 14.0671ZM7.5 1.87964C4.39688 1.87964 1.875 4.40151 1.875 7.50464C1.875 10.6078 4.39688 13.1296 7.5 13.1296C10.6031 13.1296 13.125 10.6078 13.125 7.50464C13.125 4.40151 10.6031 1.87964 7.5 1.87964Z"
                fill="#2F6787"
              />
              <path
                d="M9.65155 10.3171L7.03125 7.69683V3.28589H7.96875V7.30776L10.3125 9.6562L9.65155 10.3171Z"
                fill="#2F6787"
              />
            </svg>
          </i>
          <p style="margin: 0px !important; font-size: 11px; color: #2f6787; font-weight: 600;">{{ event.eventTime }}</p>
        </div>
      </router-link>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      events: {
        type: Array,
        required: true
      }
    },
    methods: {
    goToEventDetail(item) {
      console.log("teste");
      console.log("item is ", item);
      // Use router.push to navigate to EventDetail route with state
      this.$router.push({
        name: "AttractionDetail",
        params: { itemData: JSON.stringify(item) },
      });
    },
  },
  };
  </script>
  
  <style scoped>
  /* Add your component-specific styles here */
  </style>